<template>
  <div>
    <BreadCrumbs v-bind:bcrumbs="bcrumbs" />

    <div class="alert alert-danger" v-if="errors.load">
      {{ errors.load }}
    </div>

    <Loader v-if="loading" />

    <div v-else-if="data.course.id">
      <PageTitle v-bind:title="title" v-bind:admin="false" />

      <div
        v-if="!data.canBeFinished && data.status_id == 1"
        class="card shadow p-4 m-3"
      >
        <h4 class="mb-4">Следующая глава:</h4>
        <div class="row m-0 p-0">
          <div class="col-12 col-md-8 p-0 d-flex justify-content-start align-items-start">
            <img
              src="/icons/comp.png"
              class="pt-2"
              style="width: 32px"
              alt=""
            />
            <div class="ml-3">
              <p>
                <router-link
                  :to="{
                    name: 'chapter_show',
                    params: { id: data.fullInfo.next_chapter.id },
                  }"
                  >{{ data.fullInfo.next_chapter.name }}</router-link
                >
              </p>
              <p class="small">
                Всего глав: {{ data.fullInfo.chapters_count }} | Пройдено глав:
                {{ data.fullInfo.chapters_finished_count }}
              </p>
            </div>
          </div>
          <div
            class="col-12 col-md-4 d-flex align-items-start justify-content-md-end pr-md-5 ml-4 ml-md-0"
          >
            <router-link
              class="btn btn-success"
              :to="{
                name: 'chapter_show',
                params: { id: data.fullInfo.next_chapter.id },
              }"
              >Продолжить прохождение</router-link
            >
          </div>
        </div>
      </div>

      <!-- *************** -->

      <div class="my-5">
        <div class="alert alert-danger" v-if="errors.any">
          {{ errors.any }}
        </div>
        <div v-if="data.canBeFinished" class="alert alert-info" role="alert">
          Все главы пройдены! Нажмите "Завершить Курс"!
        </div>
        <div
          v-if="data.status_id == 5"
          class="alert alert-success"
          role="alert"
        >
          Этот Курс вами пройден.
        </div>
        <div v-if="data.status_id === 0" class="alert alert-info" role="alert">
          Нажмите "Начать Курс", чтобы увидеть содержимое.
        </div>
      </div>

      <div class="row my-5">
        <div class="col-12 col-md-6 text-center">
          <img :src="data.course.image" alt="" class="w-75" />

          <div class="d-flex flex-column  mt-3">
            <button
              v-if="data.status_id === 0"
              type="button"
              class="btn btn-primary mb-3 mx-auto w-75"
              @click.prevent="startCourse"
              style=""
            >
              Начать Курс
            </button>
            <button
              v-if="data.status_id === 1"
              type="button"
              class="btn btn-danger mb-3 mx-auto w-75"
              @click.prevent="breakCourse"
              title="Внимание! Весь прогресс будет утерян!"
              style=""
            >
              Прервать прохождение Курса
            </button>
            <button
              v-if="data.canBeFinished"
              type="button"
              class="btn btn-success mb-3 mx-auto w-75"
              @click.prevent="finishCourse"
            >
              Завершить Курс
            </button>
          </div>
        </div>
        <div class="col-12 col-md-6 text-center text-md-left">
          <div v-if="data.status != 0" style="color: gray" class="my-3">
            Статус:
            <span v-if="data.status_id == 1" class="badge badge-info"
              >в работе</span
            >
            <span v-if="data.status_id == 5" class="badge badge-success"
              >завершён</span
            >
          </div>
          <h3>Информация о Курсе:</h3>
          <div
            class="mt-3 bg-light p-2 bg-white rounded"
            v-html="data.course.description"
          ></div>
          <div>
            <span><strong>Дата создания:</strong></span>
            &nbsp;
            {{ data.course.ddate }}
          </div>
        </div>
      </div>
      <div class="row my-5">
        <div class="col-12 col-lg-6">
          <AuthorCard v-bind:user="data.user" class="w-75 mx-auto"/>
        </div>
      </div>

      <div v-if="data.status_id > 0">
        <h4>Список Глав:</h4>
        <div>
          <table class="table">
            <thead>
              <tr>
                <th>id</th>
                <th>Наименование</th>
                <th>Сортировка</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in data.chapters" :key="item.id">
                <td>{{ item.id }}</td>
                <td v-if="!item.is_final || data.canRunFinalChapter">
                  <router-link
                    :to="{ name: 'chapter_show', params: { id: item.id } }"
                    >{{ item.name }}</router-link
                  >
                  <p
                    style="font-size: 80%"
                    v-html="brFunc(item.description)"
                  ></p>
                </td>
                <td v-else>
                  {{ item.name }}
                  <!-- <span v-if="item.is_final" title="Эта глава - финальная, будет доступна после завершения всех остальных" class="badge badge-danger">fin</span> -->
                  <abbr
                    v-if="item.is_final"
                    title="Эта глава - финальная, будет доступна после завершения всех остальных"
                    class="badge badge-info"
                    >fin</abbr
                  >
                </td>
                <td>{{ item.orderby }}</td>
                <td>
                  <span v-if="item.status == 5" class="badge badge-success">{{
                    item.statusName
                  }}</span>
                  <abbr
                    v-if="item.questions.length && item.canBeFinished"
                    class="badge badge-warning"
                    title="Перейдите к главе и нажмите 'Завершить Главу'"
                  >
                    Тестирование пройдено!
                  </abbr>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <!-- ******end********* -->






      <!-- Инфа о курсе и картинка: -->
      <!--
      <div class="row p-2">
        <div class="col-md-8">
          <h3>Информация о Курсе:</h3>
          <div
            class="mt-3 bg-light p-2 bg-white rounded"
            v-html="data.course.description"
          ></div>
        </div>
        <div
          class="col-md-4 text-right"
          style="
            height: 200px;
            background-size: contain;
            background-repeat: no-repeat;
          "
          :style="{ backgroundImage: 'url(' + data.course.image + ')' }"
        ></div>
      </div>
      -->

      <!-- Автор курса, дата создания и статус, кнопки начать/закончить: -->
      <!--
      <div class="row mt-2">
        <div class="col-md-6">
          <AuthorCard v-bind:user="data.user" />
        </div>
        <div class="col-md-6 text-right">
          <div class="p-4 text-right">
            <p>
              <span><strong>Дата создания:</strong></span>
              &nbsp;
              {{ data.course.ddate }}
            </p>
            <p v-if="data.status != 0" style="color: gray">
              Статус:
              <span v-if="data.status_id == 1" class="badge badge-info"
                >в работе</span
              >
              <span v-if="data.status_id == 5" class="badge badge-success"
                >завершён</span
              >
            </p>

            <p>
              <button
                v-if="data.status_id === 0"
                type="button"
                class="btn btn-block btn-primary"
                @click.prevent="startCourse"
              >
                Начать Курс
              </button>
            </p>
            <p>
              <button
                v-if="data.status_id === 1"
                type="button"
                class="btn btn-block btn-danger"
                @click.prevent="breakCourse"
                title="Внимание! Весь прогресс будет утерян!"
              >
                Прервать прохождение Курса
              </button>
            </p>
            <p>
              <button
                v-if="data.canBeFinished"
                type="button"
                class="btn btn-block btn-success"
                @click.prevent="finishCourse"
              >
                Завершить Курс
              </button>
            </p>
          </div>
        </div>
      </div>
      <div class="alert alert-danger" v-if="errors.any">
        {{ errors.any }}
      </div>
      -->

      <!--
            <p>
                <span><strong>Автор:</strong></span>
                &nbsp;
                <router-link :to="{ name: 'user_show', params: { id: data.user.id } }">{{ data.user.fullname }}</router-link>
            </p>
            <div class="card shadow p-4 m-3">
                <h3>Автор</h3>
                <div class="row d-flex">          
                    <div class="col-12 d-flex">
                        <img :src="data.user.mainphoto" style="width: 30px; float: left; border-radius: 5px;" alt="">
                        <div class="ml-3">
                            <p><router-link :to="{ name: 'user_show', params: { id: data.user.id } }">{{ data.user.fullname }}</router-link></p>
                        </div>                    
                    </div>
                    <div class="col-12 mt-3">
                        Lorem ipsum dolor sit amet consectetur adipisicing elit. Odit cumque quod voluptate necessitatibus quo corporis suscipit qui dicta fuga dolor nulla aliquam praesentium, exercitationem incidunt culpa sequi. Consequatur, dicta in.
                    </div>
                </div>
            </div>  
            -->

      <!--
                Тут раньше было: дата создания курса, его статус, кнопки начать/кончить и т.п.
            <p>
                <span><strong>Дата создания:</strong></span>
                &nbsp;
                {{data.course.ddate}}
            </p>
            <div class="row">
                <div class="col">
                    <p v-if="data.status != 0" style="color:gray">
                        Статус: 
                        <span v-if="data.status_id == 1" class="badge badge-info">в работе</span>
                        <span v-if="data.status_id == 5" class="badge badge-success">завершён</span>
                    </p>    
                </div>
                <div class="text-end">
                    <button v-if="data.status_id === 0" type="button" class="btn btn-primary mr-3" @click.prevent="startCourse">Начать Курс</button>
                    <button v-if="data.status_id === 1" type="button" class="btn btn-danger mr-3" @click.prevent="breakCourse" title="Внимание! Весь прогресс будет утерян!">Прервать прохождение Курса</button>
                    <button v-if="data.canBeFinished" type="button" class="btn btn-success mr-3" @click.prevent="finishCourse">Завершить Курс</button>
                    <div class="alert alert-danger" v-if="errors.any">
                        {{ errors.any }}
                    </div>
                </div>
            </div>
            -->


      <!--
      <div class="mt-4">
        <div v-if="data.canBeFinished" class="alert alert-info" role="alert">
          Все главы пройдены! Нажмите "Завершить Курс"!
        </div>
        <div
          v-if="data.status_id == 5"
          class="alert alert-success"
          role="alert"
        >
          Этот Курс вами пройден.
        </div>
        <div v-if="data.status_id === 0" class="alert alert-info" role="alert">
          Нажмите "Начать Курс", чтобы увидеть содержимое.
        </div>
      </div>
      -->

      <!--
            <p class="font-weight-bold mt-4">Информация о Курсе:</p>
            <div class="mt-3 bg-light shadow p-3 mb-5 bg-white rounded" v-html="data.course.description"></div>
            -->



      <!--
      <div v-if="data.status_id > 0">
        <h4>Список Глав:</h4>
        <div>
          <table class="table">
            <thead>
              <tr>
                <th>id</th>
                <th>Наименование</th>
                <th>Сортировка</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in data.chapters" :key="item.id">
                <td>{{ item.id }}</td>
                <td v-if="!item.is_final || data.canRunFinalChapter">
                  <router-link
                    :to="{ name: 'chapter_show', params: { id: item.id } }"
                    >{{ item.name }}</router-link
                  >
                  <p
                    style="font-size: 80%"
                    v-html="brFunc(item.description)"
                  ></p>
                </td>
                <td v-else>
                  {{ item.name }}
                  <abbr
                    v-if="item.is_final"
                    title="Эта глава - финальная, будет доступна после завершения всех остальных"
                    class="badge badge-info"
                    >fin</abbr
                  >
                </td>
                <td>{{ item.orderby }}</td>
                <td>
                  <span v-if="item.status == 5" class="badge badge-success">{{
                    item.statusName
                  }}</span>
                  <abbr
                    v-if="item.questions.length && item.canBeFinished"
                    class="badge badge-warning"
                    title="Перейдите к главе и нажмите 'Завершить Главу'"
                  >
                    Тестирование пройдено!
                  </abbr>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      -->

      <!--
            <div>
                <br/><br/><br/><br/>
                <h3>-= ДЛЯ ОТЛАДКИ =-</h3>
                <h1>Course SHOW</h1>
                <p>course.id: {{data.course.id}}</p>
                <button :disabled="data.status_id != 0" type="button" class="btn btn-primary" @click.prevent="startCourse">Start Course</button>
                <button :disabled="data.status_id != 1" type="button" class="btn btn-danger" @click.prevent="breakCourse">BREAK Course</button>
                <button :disabled="data.status_id != 1" type="button" class="btn btn-success" @click.prevent="finishCourse">Finish Course</button>
                <button :disabled="data.status_id != 1" type="button" class="btn btn-success" @click.prevent="finishCourseFORCED">Finish Course FORCED</button>
                <div class="alert alert-danger" v-if="errors.any">
                    {{ errors.any }}
                </div>
            </div>
-->
    </div>
  </div>
</template>
<script>
import axios from "axios";
import Loader from "@/components/Loader";
import PageTitle from "@/components/PageTitle";
import BreadCrumbs from "@/components/BreadCrumbs";
import AuthorCard from "@/components/AuthorCard";
import moment from "moment";
//import jQuery from 'jquery'
export default {
  data() {
    return {
      loading: true,
      data: [],
      errors: { load: "", any: "" },
      title: "",
      bcrumbs: [],
    };
  },
  async mounted() {
    //this.hui = moment().format('MMMM Do YYYY, h:mm:ss a');
    this.hui = moment().format("DD.MM.YYYY");
    this.loadData();
  },
  methods: {
    //
    // Переносы из textarea конвертим в переносы для абзаца.
    //
    brFunc(str) {
      if (str) {
        return str.replace(/\n/g, "<br />");
      }
    },
    async loadData() {
      //console.log(this.$route.params.id);
      this.errors.load = "";
      try {
        this.loading = true;
        let response = await axios.get("courses/" + this.$route.params.id);
        this.data = response.data;
        // cookieme
        // console.log(this.data);
        // this.data.status_id = 5;
        // this.data.canBeFinished = true;
        // cookiemeend
        this.title = this.data.course.name;
        this.data.course.ddate = moment(this.data.course.created_at).format(
          "DD.MM.YYYY"
        );
        this.bcrumbs = response.data.bcrumbs;
        this.loading = false;
      } catch (e) {
        this.errors.load = "Ошибка при загрузке данных";
      }
    },
    async startCourse() {
      this.errors.any = "";
      try {
        let response = await axios.post(
          "courses/" + this.$route.params.id + "/start"
        );
        if (response.status == 200) {
          this.loading = true;
          this.loadData();
        }
      } catch (e) {
        if (e.response.status == 520) {
          this.errors.any = e.response.data.error;
        } else {
          this.errors.any = "Неизвестная ошибка при старте Курса.";
        }
      }
    },
    async breakCourse() {
      this.errors.any = "";
      try {
        let response = await axios.post(
          "courses/" + this.$route.params.id + "/break"
        );
        if (response.status == 200) {
          this.loading = true;
          this.loadData();
        }
      } catch (e) {
        if (e.response.status == 520) {
          this.errors.any = e.response.data.error;
        } else {
          this.errors.any = "Неизвестная ошибка при прерывании Курса.";
        }
      }
    },
    async finishCourse() {
      this.errors.any = "";
      try {
        let response = await axios.post(
          "courses/" + this.$route.params.id + "/finish"
        );
        if (response.status == 200) {
          this.loading = true;
          this.loadData();
        }
      } catch (e) {
        if (e.response.status == 520) {
          this.errors.any = e.response.data.error;
        } else {
          this.errors.any = "Неизвестная ошибка при завершении Курса.";
        }
      }
    },
    async finishCourseFORCED() {
      this.errors.any = "";
      try {
        let response = await axios.post(
          "courses/" + this.$route.params.id + "/finishFORCED"
        );
        if (response.status == 200) {
          this.loading = true;
          this.loadData();
        }
      } catch (e) {
        if (e.response.status == 520) {
          this.errors.any = e.response.data.error;
        } else {
          this.errors.any = "Неизвестная ошибка при завершении Курса.";
        }
      }
    },
  },
  components: {
    Loader,
    PageTitle,
    BreadCrumbs,
    AuthorCard,
  },
};
</script>


<style scoped>
</style>